import Vue from 'vue'
import Vuex from 'vuex'
import { menuConfig } from '@/router'
import { menuConfig as menuConfigManager } from '@/router/index-manager'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 菜单配置
    menuConfig: process.env.type === 'manager' ? menuConfigManager : menuConfig
  },

  mutations: {},

  actions: {}
})
